import React, { useMemo, useState } from 'react'
import ModalCreateCustomerSupport from '../../../_payairo/partials/widgets/_new/modal/ModalCreateCustomerSupport'
import { useLayout } from '../../../_payairo/layout/core'
import { useAuth } from '../../modules/auth'
import { isManagerRole } from '../../utils/helper'

/**
 * Only Admin (full staff scope) and Manager may create accounts via Add Role.
 * Manager: Spectator + Customer Support only (enforced in modal + API).
 */
const RoleManagementRightToolbar = () => {
  const { currentUser, auth } = useAuth()
  const [showCustomerSupport, setShowCustomerSupport] = useState(false)
  const { refreshCustomerSupportUsers } = useLayout()

  const role = currentUser?.role || auth?.role || currentUser?.user_type
  const userType = currentUser?.user_type || auth?.user_type

  const isCustomerSupport =
    role === 'CUSTOMER_SUPPORT' || role === 'CustomerSupport' || userType === 'CustomerSupport'
  const isSpectator = role === 'Spectator' || userType === 'Spectator'
  const isManager = isManagerRole(role, userType)

  const canAddRole = useMemo(() => {
    if (isCustomerSupport || isSpectator) return false
    const isAdminScope = !isCustomerSupport && !isSpectator && !isManager
    return isAdminScope || isManager
  }, [isCustomerSupport, isSpectator, isManager])

  if (!canAddRole) {
    return null
  }

  return (
    <div className='d-flex gap-2'>
      <button
        type='button'
        className='btn btn-sm fw-bold btn-success'
        onClick={() => setShowCustomerSupport(true)}
      >
        Add Role
      </button>
      <ModalCreateCustomerSupport
        show={showCustomerSupport}
        setShow={setShowCustomerSupport}
        onSuccess={refreshCustomerSupportUsers}
      />
    </div>
  )
}

export default RoleManagementRightToolbar
